var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1B8F15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9442 7.99995C12.9442 10.3624 11.029 12.2777 8.66645 12.2777C6.30395 12.2777 4.38867 10.3624 4.38867 7.99995C4.38867 5.63745 6.30395 3.72217 8.66645 3.72217C11.029 3.72217 12.9442 5.63745 12.9442 7.99995ZM6.72201 8.38883L7.30534 7.8055L8.08312 8.58328L10.0276 6.63883L10.6109 7.22217L8.08312 9.74995L6.72201 8.38883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconTwo);
export default __webpack_public_path__ + "static/media/cardIconTwo.3f06910e5df9516a28c960ba8d8017fc.svg";
export { ForwardRef as ReactComponent };